//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BaseCmsBlock from '../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin'
export default BaseCmsBlock.extend({
  name: 'ImageGalleryBlock',
  data () {
    // console.log(this,)
    return {
      index: null
    }
  },
  computed: {
    images () {
      return this.extras.items.map((item) => {
        return {
          src: item.src,
          title: item.caption
        }
      })
    }
  },
  methods: {
    setClassGrid (idx) {
      if (idx > 4) {
        idx = idx - Math.floor(idx / 5) * 5
      }
      if (idx % 4 === 0) { return 'md:grid-cols-4' }
      if (idx % 3 === 0) { return 'md:grid-cols-3' }
      if (idx % 2 === 0) { return 'md:grid-cols-2' }
      if (idx % 1 === 0) { return 'md:grid-cols-1' }
    }
  }
})
